import { each, isObject, unset } from 'es-toolkit/compat';

export function omitByRecursivelyInPlace<T extends object | null | undefined>(
  value: T,
  iteratee: (v: any, k: string) => any,
) {
  each(value, (v, k) => {
    if (iteratee(v, k)) {
      unset(value, k);
    } else if (isObject(v)) {
      omitByRecursivelyInPlace(v, iteratee);
    }
  });

  return value;
}
